/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

import _Collapse from './collapse.mjs';
import _CollapsePanel from './collapse-panel.mjs';
import withInstall from '../utils/withInstall.mjs';
import './style/css.mjs';
import './type.mjs';
import '../_chunks/dep-6e49aa22.mjs';
import '../_chunks/dep-6da93342.mjs';
import '../_chunks/dep-8d3c9348.mjs';
import '../_chunks/dep-d531a7f4.mjs';
import 'vue';
import './props.mjs';
import '../hooks/useVModel.mjs';
import 'lodash-es';
import '../_chunks/dep-5112e56c.mjs';
import '../utils/render-tnode.mjs';
import '../hooks/useConfig.mjs';
import '../config-provider/hooks/useConfig.mjs';
import '../config-provider/utils/context.mjs';
import '../_chunks/dep-99da72b8.mjs';
import '../_chunks/dep-b0ea6825.mjs';
import '../_chunks/dep-2705c570.mjs';
import '../_chunks/dep-bc824998.mjs';
import '../config-provider/type.mjs';
import './collapse-panel-props.mjs';
import '../common-components/fake-arrow.mjs';
import '../hooks/useCollapseAnimation.mjs';

var Collapse = withInstall(_Collapse);
var CollapsePanel = withInstall(_CollapsePanel);

export { Collapse, CollapsePanel, Collapse as default };
//# sourceMappingURL=index.mjs.map
